import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "login-page" }
const _hoisted_3 = { class: "login-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "login-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.loadIcon,
          alt: "Logo"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('app.name')), 1),
        (_ctx.finished)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString(_ctx.$t('remerciements.note.reclamation.success')), 1))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_ctx.$t('remerciements.note.reclamation.error')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}